<template>
	<div class="yourdetails-banner">
		<div class="yourdetails-banner__heading">
			<h1>{{ headline }}</h1>
			<p v-if="subheadline">
				{{ subheadline }}
			</p>
		</div>
	</div>
</template>

<script>
import { useBrand } from '@/composables/useBrand';
import md5 from 'js-md5';

	export default {
		name: 'ConfirmationBanner',
		setup() {
			const { getBrandConfiguration, detectBrand } = useBrand();
			return { getBrandConfiguration, detectBrand };
		},
		props: {
			headline: undefined,
			subheadline: undefined,
			lang: { type: String, default: 'en' },
			translations: { type: Object, default: () => ({}) },
		},
		computed: {},
		data() {
			return {
				brandConfig: null,
			};
		},
		methods: {
			getBrandText(key, fallback = '') {
				if (!this.brandConfig) return fallback;
				return this.brandConfig.confirmation?.[key] || fallback;
			},
			hasSpecialFeature(feature) {
				if (!this.brandConfig) return false;
				return this.brandConfig.features?.[feature] || false;
			},
			getrans(key, brandId = null, lang = null) {
				const finalBrandId = brandId || this.detectBrand() || 'DEFAULT';
				const finalLang = lang || this.lang || 'en';
				const translationKey = md5(`${finalBrandId}_${finalLang}_${key}`);
				return this.translations[translationKey] || key;
			},
		},
		mounted() {
			this.brandConfig = this.getBrandConfiguration();
		},
		updated() {},
	};
</script>

<style scoped lang="scss">
	@import '@/assets/sass/variables.scss';
	.yourdetails-banner {
		max-width: 1280px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
    text-align: center;

		@media screen and (min-width: 768px) {
			flex-direction: row;
			align-items: center;
			justify-content: center;
		}

		&__heading {
			color: #ffffff;

			h1 {
				font-size: 1.875rem;
				font-weight: 700;
			}

			p {
				font-size: 1.16rem;
				font-weight: 600;
			}

			@media screen and (min-width: 768px) {
				h1 {
					font-size: 1.875rem;
					margin: 0;
				}

				p {
					font-size: 1.375rem;
					margin-bottom: 0;
				}
			}
		}
	}
</style>
